import React from 'react';
import { useHasChangedDeep } from './useHasChanged';

export function useMemoized<T>(value: T): T {
  const [val, setVal] = React.useState(value);

  const { hasChanged } = useHasChangedDeep([value]);
  React.useEffect(() => {
    if (!hasChanged) return;
    setVal(value);
  }, [hasChanged, value]);

  // use new value if it has changed so we don't use a stale value
  return hasChanged ? value : val;
}
